<ftr-time-input
  [id]="id"
  [label]="label"
  [name]="name"
  [submitAttempted]="submitAttempted"
  [control]="control"
  [highlightError]="highlightError"
  [placeholder]="placeholder"
  [invalidTimeMessage]="invalidTimeMessage"
  (inputChanged)="(onInputChanged)"
  [timeStringParseMethods]="timeStringParseMethods"
  [timeFormat]="timeFormat"
></ftr-time-input>
